import { useIdentity } from '$api-clients/hooks';
import type { UserInformation } from '../../types/user';
import { getUserInformation } from '../../utils/user';

export const useUserInformation = (
  userId?: string,
): UserInformation | undefined => {
  const { data: fetchedUserData } = useIdentity(
    '/users/{userId}',
    userId ? { params: { path: { userId } } } : null,
  );

  if (fetchedUserData) {
    return getUserInformation(fetchedUserData);
  }

  return undefined;
};
